module.exports = __webpack_public_path__ + "img/site1.4e98e33d.jpg";